import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MenuComponent } from "./menu/menu.component";
import { FiltersComponent } from "./filters/filters.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TableComponent } from "./table/table.component";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { InputSelectorWithSearchComponent } from "./input-selector-with-search/input-selector-with-search.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RichTextEditorComponent } from "./rich-text-editor/rich-text-editor.component";
import { TranslateModule } from "@ngx-translate/core";
import { TreeComponent } from "./tree/tree.component";
import { MultiSelectDropdownComponent } from "./multi-select-dropdown/multi-select-dropdown.component";
import { CompareReleasePeticionComponent } from "./compare-release-peticion/compare-release-peticion.component";
import { CommentsHistoryPeticionComponent } from "./comments-history-peticion/comments-history-peticion.component";
import { ViewerPDFComponent } from "./viewer-pdf/viewer-pdf.component";

import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";

//Angular material
import { MatTreeModule } from "@angular/material/tree";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { DynamicFieldsComponent } from "./dynamic-fields/dynamic-fields.component";
import { ModalFormComponent } from "./modal-form/modal-form.component";
import { ModalTableComponent } from "./modal-table/modal-table.component";
import { StatesComponent } from "./states/states.component";
import { ReasigneAnalystComponent } from "./reasigne-analyst/reasigne-analyst.component";

import { CoreModule } from "../core/core.module";
import { ListRelatedRequestsComponent } from "./list-related-requests/list-related-requests.component";
import { FormFieldsComponent } from "./form-fields/form-fields.component";
import {UpperCaseInputDirective} from "./directives/uppercase-input.directive";

// Angular CDK Layout para control de dispositivos
import { LayoutModule } from '@angular/cdk/layout';

@NgModule({
  declarations: [
    MenuComponent,
    FiltersComponent,
    TableComponent,
    InputSelectorWithSearchComponent,
    RichTextEditorComponent,
    TreeComponent,
    MultiSelectDropdownComponent,
    CompareReleasePeticionComponent,
    CommentsHistoryPeticionComponent,
    DynamicFieldsComponent,
    ModalFormComponent,
    ModalTableComponent,
    StatesComponent,
    ReasigneAnalystComponent,
    ListRelatedRequestsComponent,
    ViewerPDFComponent,
    FormFieldsComponent,
    UpperCaseInputDirective,
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    SweetAlert2Module,
    MatTreeModule,
    MatCheckboxModule,
    TranslateModule,
    NgMultiSelectDropDownModule.forRoot(),
    CoreModule,
    NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    LayoutModule,
  ],
  exports: [
    FormFieldsComponent,
    MenuComponent,
    FiltersComponent,
    TableComponent,
    TreeComponent,
    SweetAlert2Module,
    InputSelectorWithSearchComponent,
    RichTextEditorComponent,
    TranslateModule,
    MatTreeModule,
    MultiSelectDropdownComponent,
    CompareReleasePeticionComponent,
    CommentsHistoryPeticionComponent,
    DynamicFieldsComponent,
    ModalFormComponent,
    ModalTableComponent,
    StatesComponent,
    ReasigneAnalystComponent,
    ListRelatedRequestsComponent,
    ViewerPDFComponent,
    NgxExtendedPdfViewerModule,
    UpperCaseInputDirective,
  ],
})
export class SharedModule {}
